import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { Link } from 'react-router';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

import NoData from '../../../components/NoData/NoData';
import { setChart } from '../../../components/Filter/FilterActions';
import { getData } from '../MonteCarloActions';

import Filter from '../../../components/Filter/Filter';
import { DatePicker, Options } from '../../../components/Filter/components';

import MonteCarloChart from './../components/MonteCarloChart';

import { trackTeamDashboardView, trackHowToOpened } from '../../../util/mixpanel';

import './../MonteCarlo.scss';

class MonteCarlo extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    if (this.props.dashboard && this.props.dashboard._id && this.props.dataIsLoading === false) {
      this.props.setChart('mc');

      trackTeamDashboardView('montecarlodates');
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.hash != this.props.hash && this.props.dataIsLoading === false) {
      this.handleChange();
    }
  }

  handleChange = force => {
    if (force || !this.props.dataIsLoading) {
      this.props.getData();
    }
  };

  trackHowToMCDatesOpen() {
    trackHowToOpened('montecarlodates');
  }

  render() {
    const tooltip = (
      <div className="more_info_tooltip">
        <div className="more_info-inner">
          <p>Use the chart to:</p>
          <ul>
            <li>Set realistic delivery dates you can actually meet</li>
            <li>Identify the probability of missing a deadline early</li>
            <li>Account for performance changes in real time</li>
          </ul>
          <a
            //href={`https://www.youtube.com/watch?v=U2uYUjZK8f8&list=PLdQ4qpF6dHcJ5KpN51NyCNUb5bS6bbrpC&index=8`}
            href={`https://getnave.com/monte-carlo-delivery-date`}
            target="_blank"
            onClick={this.trackHowToMCDatesOpen}
            onAuxClick={this.trackHowToMCDatesOpen}
            className='btn btn-secondary'
            >
              Learn more
          </a>
        </div>
      </div>
    );

    const totalItems = !this.props.data ? 0 : _.reduce(this.props.data, (p, c) => {
      return p + _.reduce(c.data, (p, c) => p + c.details.length, 0);
    }, 0);

    return (
      <div className="content-wrap">
        <Helmet title={`Monte Carlo: Delivery Date${this.props.dashboard ? ' | ' + this.props.dashboard.name : ''}`} />
        <Filter totalItems={totalItems} navigator dateformat enablePercentiles montecarlo />
        <div className="chart_box_view">
          <div className="dashboard_head">
            <div className="flex-layout">
              <h1>Monte Carlo: Delivery Date</h1>
              <div className="more_info_content">
                <span className="more_info"></span>
                {tooltip}
              </div>
            </div>
            <div className="button_tools">
              {/*<div className="tracking">
                <Link className="btn btn-primary btn-md" to={`/forecasts/${this.props.dashboard._id}`}>
                  Continuous Forecasting
                </Link>
              </div>*/}
              <Options showNavigator />
              <DatePicker />
            </div>
          </div>
          <div className="diagram_details">
            <MonteCarloChart id="MonteCarlo" data={this.props.data} />
            <NoData show={this.props.noData} loading={this.props.isLoading} />
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setChart: name => dispatch(setChart(name)),
    getData: () => dispatch(getData())
  };
};

const mapStateToProps = state => {
  const customFields = _.map(state.filters.allCustomFields, cf => {
    return state.filters.mc[`selected${cf}`];
  });

  return {
    user: state.auth.user,
    hash: state.filters.mc.hash,
    data: state.mc.data,
    noData: state.mc.noData,
    isLoading: state.mc.isLoading,
    dashboard: state.dashboards.selected,
    dataIsLoading: state.app.isLoading,
    customFields
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MonteCarlo);
